import React from 'react';
export function General() {
  return <div data-id="element-2217">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2218">
        General Settings
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2219">
        Manage your account and application preferences
      </p>

      <div className="space-y-6" data-id="element-2220">
        {/* Company Information */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2221">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2222">
            Company Information
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-2223">
            <div data-id="element-2224">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2225">
                Company Name
              </label>
              <input type="text" placeholder="Enter company name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2226" />
            </div>
            <div data-id="element-2227">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2228">
                Industry
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2229">
                <option data-id="element-2230">Automotive</option>
                <option data-id="element-2231">Technology</option>
                <option data-id="element-2232">Retail</option>
              </select>
            </div>
          </div>
        </div>

        {/* Regional Settings */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2233">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2234">
            Regional Settings
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-2235">
            <div data-id="element-2236">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2237">
                Timezone
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2238">
                <option data-id="element-2239">Asia/Kolkata (IST)</option>
                <option data-id="element-2240">America/New_York (EST)</option>
                <option data-id="element-2241">Europe/London (GMT)</option>
              </select>
            </div>
            <div data-id="element-2242">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2243">
                Currency
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2244">
                <option data-id="element-2245">INR (₹)</option>
                <option data-id="element-2246">USD ($)</option>
                <option data-id="element-2247">EUR (€)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="flex justify-end" data-id="element-2248">
          <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-2249">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
}